import { render } from "./learningCenterSupportFloatingIcon.vue?vue&type=template&id=58aa7435"
import script from "./learningCenterSupportFloatingIcon.vue?vue&type=script&lang=js"
export * from "./learningCenterSupportFloatingIcon.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./learningCenterSupportFloatingIcon.vue?vue&type=style&index=0&id=58aa7435&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__